<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                Filtros
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    label="Fecha inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Fecha final"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="seeIn"
                                :items="[{val:'cantidad', text:'Cantidad'}, {val:'valorado', text:`Valorado ${money}`}]"
                                label="Ver en"
                                item-value="val"
                                item-text="text"
                                outlined
                                dense
                                hide-details
                            ></v-select>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/export-inventory?date_init=${dateInit}&date_end=${dateEnd}&type=${seeIn}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            Exportar
                        </v-btn>

                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch('')"
                        >
                            Limpiar
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Inventario
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="dialogStock = !dialogStock"
                >Agregar stock</v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr v-if="seeIn=='valorado' && !overlay" class="bg-grey lighten-2">
                        <td colspan="2">
                            <v-chip
                                color="primary"
                                outlined
                            >
                                <strong>TOTAL</strong>
                            </v-chip>
                        </td>
                        <td></td>
                        <td><strong>{{ sumaTotal('pro_init') }}</strong></td>
                        <td><strong>{{ sumaTotal('pro_input') }}</strong></td>
                        <td><strong>-{{ sumaTotal('pro_output') }}</strong></td>
                        <td class="text-right"><strong>{{ sumaTotal('pro_current') }}</strong></td>
                    </tr>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Código</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='product_code', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='product_code', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="codeProduct"
                                                    label="Producto"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('product')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Producto</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='product_id', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='product_id', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtProduct"
                                                    label="Producto"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('product')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span v-if="seeIn=='cantidad'">Medida</span>
                                <span v-if="seeIn=='valorado'">Moneda</span>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <v-select
                                                v-model="seeIn"
                                                :items="[{val:'cantidad', text:'Cantidad'}, {val:'valorado', text:`Valorado ${money}`}]"
                                                label="Ver en"
                                                item-value="val"
                                                item-text="text"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Stock Inicial</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'inv_init' : 'pro_init'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'inv_init' : 'pro_init'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtStockInit"
                                                    label="Stock Inicial"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="nuimber"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('stock_init')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>(+) Compras</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'qty_input' : 'pro_input'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'qty_input' : 'pro_input'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtCompras"
                                                    label="Compras"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('compras')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>(-) Salidas</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'qty_output' : 'pro_output'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'qty_output' : 'pro_output'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSalidas"
                                                    label="Salidas"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('salidas')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-right">
                            <div class="d-flex align-center">
                                <span>Stock final</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'inv_current' : 'pro_current'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'inv_current' : 'pro_current'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtStockFin"
                                                    label="Stock final"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('stock_final')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in inventory" :key="index">
                        <td>{{ item?.product?.code }}</td>
                        <td>{{ item?.product?.name }}</td>
                        <td>
                            <span v-if="seeIn=='cantidad'">Unidades</span>
                            <span v-if="seeIn=='valorado'">{{ money }}</span>
                        </td>
                        <td>
                            <span v-if="seeIn=='cantidad'">{{ item.inv_init }}</span>
                            <span v-if="seeIn=='valorado'">{{ roundDecimals(item.pro_init) }}</span>
                        </td>
                        <td>
                            <span v-if="seeIn=='cantidad'">{{ item.qty_input }}</span>
                            <span v-if="seeIn=='valorado'">{{ roundDecimals(item.pro_input) }}</span>
                        </td>
                        <td>
                            <span v-if="seeIn=='cantidad'">-{{ item.qty_output }}</span>
                            <span v-if="seeIn=='valorado'">-{{ roundDecimals(item.pro_output) }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="seeIn=='cantidad'">{{ item.inv_current }}</span>
                            <span v-if="seeIn=='valorado'">{{ roundDecimals(item.pro_current) }}</span>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable" v-if="tmpType=='all'"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
            v-if="tmpType=='all'"
        ></v-pagination>
        <!-- end card main -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogStock"
            max-width="800"
            scrollable
        >
            <v-card>
                <v-card-title>
                    Agregar estock
                </v-card-title>
                <v-card-text>

                    <v-card-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar..."
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                    </v-card-title>

                    <div class="text-right blue-grey darken-4 white--text px-2 py-3 text-h5">
                        <strong>Total en {{ money }}</strong> {{ tmpTotal }}
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="listProduct"
                        :search="search"
                    >
                        <template v-slot:item.unit="{ item }">
                            Unidades
                        </template>
                        <template v-slot:item.quantity="{ item }">
                            <v-text-field
                                v-model="item.quantity"
                                type="number"
                                outlined
                                dense
                                min="0"
                                step="1"
                                hide-details
                                class="my-2"
                                @input="calculateTotal()"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.cost_min="{ item }">
                            <v-text-field
                                v-model="item.cost_min"
                                type="number"
                                outlined
                                dense
                                min="0"
                                hide-details
                                class="my-2"
                                @input="calculateTotal()"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.total="{ item }">
                            <span class="d-block text-right">{{ item.quantity * item.cost_min }}</span>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogStock = false"
                    >Cancelar</v-btn>
                    <v-btn
                        color="primary"
                        @click="addStock"
                    >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- END dialog -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Productos',
                    disabled: false,
                    href: '/admin/products',
                },
                {
                    text: 'Inventario',
                    disabled: true,
                    href: '',
                }
            ],
            // filter
            dateInit: '',
            dateEnd: '',
            menuInit: false,
            menuEnd: false,
            seeIn: 'cantidad',
            // data
            inventory: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            // stock
            dialogStock: false,
            // tabla de productos
            search: '',
            headers: [
                { text: 'Producto', align: 'start', value: 'name' },
                { text: 'Unidad de medida', value: 'unit' },
                { text: 'Cantidad', value: 'quantity' },
                { text: 'Costo unitario', value: 'cost_min' },
                { text: 'Total valorado', value: 'total' }
            ],
            listProduct: [],
            tmpTotal: 0,
            // filters
            orderType: 'DESC',
            orderBy: 'created_at',
            codeProduct: '',
            txtProduct: '',
            txtStockInit: '',
            txtCompras: '',
            txtSalidas: '',
            txtStockFin: '',
            tmpType: 'all'
        }
    },
    props: ['slug', 'money'],
    mounted() {
        this.getDataInventory()
        this.getDataProducts()

        this.headers[3].text = 'Costo unitario en ' + this.money
        this.headers[4].text = 'Total valorado en ' + this.money
    },
    methods: {
        calculateTotal() {
            this.tmpTotal = 0
            this.listProduct.forEach(item => {
                this.tmpTotal += item.quantity * item.cost_min
            })
        },
        /** sdfdsf */
        cleanSearch(type='') {
            if (type=='') {
                if ( (this.seeIn !== '') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.dateInit = '';
                    this.dateEnd = '';
                    this.seeIn = 'cantidad';
                    this.page = 1;
                    this.getDataInventory()
                }
            } else {
                switch (type) {
                    case 'product':
                        this.txtProduct = [];
                        this.codeProduct = "";
                        this.getDataInventory();
                        break;
                    case 'stock_init':
                        this.txtStockInit = ''
                        this.getDataInventory();
                        break;
                    case 'compras':
                        this.txtCompras = ''
                        this.getDataInventory();
                        break;
                    case 'salidas':
                        this.txtSalidas = ''
                        this.getDataInventory();
                        break;
                    case 'stock_final':
                        this.txtStockFin = ''
                        this.getDataInventory();
                        break;
                    default:
                        break;
                }
            }
        },
        changePage(event) {
            this.page = event;
            this.getDataInventory();
        },
        processSearch() {
            this.page = 1
            this.getDataInventory()
        },
        /**
         * obtener datos del inventario
         */
        async getDataInventory() {
            this.overlay = true
            this.inventory = []
            await axios.get(`/admin/inventories?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &see_in=${this.seeIn}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &product=${this.txtProduct}
                            &code_product=${this.codeProduct}
                            &stock_init=${this.txtStockInit}
                            &compras=${this.txtCompras}
                            &salidas=${this.txtSalidas}
                            &stock_final=${this.txtStockFin}
            `)
            .then((response) => {
                // console.log(response)
                if (response.data[1] == 'all') {
                    const resp = response.data[0]
                    this.inventory = resp.data

                    this.pageTable = `Mostrando <strong>${resp.from??0} - ${resp.to??0}</strong> de un total de <strong>${resp.total}</strong>`
                    this.totalPage = resp.last_page

                    this.tmpType = 'all'
                } else {
                    const resp = response.data[0]

                    Object.values(resp).forEach(el => {
                        this.inventory.push({
                            id: el[0].id,
                            product: el[0].product,
                            inv_init: el.map(el => el.inv_init).reduce((a, b) => (+a) + (+b)),
                            pro_init: el.map(el => el.pro_init).reduce((a, b) => (+a) + (+b)),
                            qty_output: el.map(el => el.qty_output).reduce((a, b) => (+a) + (+b)),
                            pro_output: el.map(el => el.pro_output).reduce((a, b) => (+a) + (+b)),
                            qty_input: el.map(el => el.qty_input).reduce((a, b) => (+a) + (+b)),
                            pro_input: el.map(el => el.pro_input).reduce((a, b) => (+a) + (+b)),
                            inv_current: el.map(el => el.inv_current).reduce((a, b) => (+a) + (+b)),
                            pro_current: el.map(el => el.pro_current).reduce((a, b) => (+a) + (+b))
                        })
                    });

                    this.tmpType = 'by_date'
                }

                this.overlay = false
            })
            .catch((error) => {
                console.log(error)
                this.overlay = false
            })
        },

        /**
         * totales
         */
        sumaTotal(type) {
            let total = 0
            this.inventory.forEach(item => {
                total += (+item[type])
            })
            return total.toFixed(this.numberDecimals)
        },

        /**
         * stock
         */
        async getDataProducts() {
            this.overlay = true
            this.listProduct = []
            this.search = ''
            await axios.get(`/admin/temp-products`)
            .then((response) => {
                // console.log(response)
                response.data.forEach(prod => {
                    this.listProduct.push({
                        id: prod.id,
                        name: prod.name,
                        quantity: 0,
                        cost_min: 0,
                        internal_stock: prod.internal_stock,
                        unit_cost: prod.unit_cost
                    })
                });
                this.overlay = false
            })
            .catch((error) => {
                console.log(error)
                this.overlay = false
            })
        },
        async addStock() {
            const tmpProds = this.listProduct.filter(prod => prod.quantity > 0)

            if (tmpProds.length > 0) {
                await axios.post('/admin/add-stock', {products: JSON.stringify(tmpProds)})
                .then((response) => {
                    // console.log(response)
                    if (response.data == 'ok') {
                        this.$notify.success('Se han guardado los cambios');
                        this.getDataProducts()
                        this.getDataInventory()
                    }
                    this.dialogStock = false
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                })
            } else {
                this.$notify.error('Por favor seleccione al menos un producto');
            }
        },
        roundDecimals(num) {
            return (+num).toFixed(this.numberDecimals)
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
